// eslint-disable-next-line @1js/office-online-rules/no-v8-imports-for-fluentui -- disabling for existing usage
import type { IButtonStyles } from "@fluentui/react";
// eslint-disable-next-line @1js/office-online-rules/no-v8-imports-for-fluentui -- disabling for existing usage
import { memoizeFunction } from "@fluentui/react";
import type { ITheme } from "@fluentui/react/lib/Styling";
import { concatStyleSets } from "@fluentui/react/lib/Styling";

import type { ActionControlSemanticColors } from "@1js/acui-common";
import {
  ActionControlSize,
  commonHighContrastNoAdjustStyles,
  getActionControlSemanticColorsWithTheme,
  isTwoLineText,
} from "@1js/acui-common";

import type { SizedButtonStyles } from "../../styling";
import { getSizedButtonStyles } from "../../styling";
import type { AppFlyoutAnchorProps } from "./AppFlyoutAnchor.Props";

export const menuTextContainerClass = "ribbon-menu-text";
export const menuTextLine2Class = "ribbon-menu-line2";
export const menuTextChevronClass = "ribbon-menu-chevron";

export const getActionFlyoutAnchorStyles = memoizeFunction(
  (theme: ITheme, hideChevron: boolean): IButtonStyles => {
    const actionControlSemanticColors: ActionControlSemanticColors =
      getActionControlSemanticColorsWithTheme(theme);
    return {
      root: {
        paddingLeft: 9,
        paddingRight: hideChevron ? 9 : 0,
      },
      label: {
        marginRight: 2,
        marginLeft: 10,
      },
      menuIcon: {
        fill: actionControlSemanticColors.textColor,
      },
      textContainer: {
        selectors: {
          [`.${menuTextChevronClass}`]: {
            fill: actionControlSemanticColors.textColor,
          },
        },
      },
    };
  }
);

const actionFlyoutAnchorSizedStyles: SizedButtonStyles = {
  large: {
    textContainer: {
      selectors: {
        [`.${menuTextContainerClass}`]: [
          {
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
          },
          commonHighContrastNoAdjustStyles,
        ],
        [`.${menuTextLine2Class}`]: {
          lineHeight: "normal",
        },
        [`.${menuTextChevronClass}`]: {
          width: 8,
          height: 8,
          padding: "0px 2px",
        },
      },
    },
  },
};

const actionFlyoutAnchorTwoLineTextStyles: SizedButtonStyles = {
  large: concatStyleSets(actionFlyoutAnchorSizedStyles.large, {
    textContainer: {
      selectors: {
        [`.${menuTextLine2Class}`]: {
          lineHeight: "normal",
        },
      },
    },
  }),
};

export function getSizedFlyoutAnchorStyles(
  controlProps: Partial<AppFlyoutAnchorProps>,
  size: ActionControlSize,
  existingStyles: IButtonStyles | undefined
): IButtonStyles | undefined {
  const showLabel = !controlProps.hideLabel && controlProps.label;
  const anchorStyles =
    size === ActionControlSize.Large &&
    showLabel &&
    isTwoLineText(controlProps.label!)
      ? actionFlyoutAnchorTwoLineTextStyles
      : actionFlyoutAnchorSizedStyles;
  return getSizedButtonStyles(size, existingStyles, anchorStyles);
}
